import { useState } from "react";
import {
  Box,
  Tag,
  Text,
  IconButton,
  HStack,
  Input,
  Button,
  Flex,
  List,
  ListItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { EditIcon, CloseIcon } from "@chakra-ui/icons";
import { recruitConstant } from "../constant";
import { allSkills } from "../data/panel.Data";
import colors from "common/theme/foundations/colors";

const SkillsSection = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [skills, setSkills] = useState([]);
  const [newSkill, setNewSkill] = useState("");
  const [tempSkills, setTempSkills] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [isOpenSkills, setIsOpenSkills] = useState(false);

  const maxVisibleSkills = 1;

  const filteredSkills = allSkills.filter(
    (skill) =>
      skill.toLowerCase().includes(newSkill.toLowerCase()) &&
      !tempSkills.includes(skill)
  );

  const addSkill = (skill) => {
    if (
      tempSkills.length < 15 &&
      skill.trim() !== "" &&
      !tempSkills.includes(skill)
    ) {
      setTempSkills([...tempSkills, skill.trim()]);
      setNewSkill("");
    }
  };

  const removeSkill = (skillToRemove) => {
    setTempSkills(tempSkills.filter((skill) => skill !== skillToRemove));
  };

  const handleSave = () => {
    setSkills(tempSkills);
    setShowAll(false);
    onClose();
  };

  const handleCancel = () => {
    setTempSkills(skills);
    onClose();
  };

  return (
    <Box
      py={2}
      px={3}
      borderRadius="lg"
      className="skillsBox"
      boxShadow="sm"
      maxW="300px"
      mx="auto"
    >
      {skills.length === 0 && (
         <HStack mb={0} justify="space-between">
         <Text className="label">{recruitConstant.skills}</Text>
         <IconButton
           icon={<EditIcon />}
           size="sm"
           variant="ghost"
           height={"18px"}
           color="green.500"
           onClick={() => {
             setTempSkills([...skills]);
             onOpen();
           }}
         />
       </HStack>
      )}
     

      {skills.length > 0 && (
        <Box px={"0px"}>
          <Flex px={"0px"} wrap="wrap" gap={0} alignItems={"center"}>
            {(showAll ? skills : skills.slice(0, maxVisibleSkills)).map(
              (skill, index) => (
                <Tag
                  px={"0px"}
                  lineHeight={"12px"}
                  backgroundColor={"transparent"}
                  key={index}
                >
                  {skill},
                </Tag>
              )
            )}
            {skills.length > maxVisibleSkills && (
              <Button
                size="xs"
                color={colors.textColor}
                fontWeight={"600"}
                variant="link"
                ms={1}
                onClick={() => {
                  setTempSkills([...skills]);
                  onOpen();
                }}
              >
                {showAll
                  ? recruitConstant.showLess
                  : `+${skills.length - maxVisibleSkills} ${
                      recruitConstant.more
                    }`}
              </Button>
            )}
          </Flex>
        </Box>
      )}

      <Modal isOpen={isOpen} onClose={onClose} size="md">
        <ModalOverlay />
        <ModalContent maxWidth={"700px"}>
          <ModalHeader>{recruitConstant.editSkills}</ModalHeader>
          <ModalCloseButton />

          <ModalBody className="modalBody">
            <Box p={3} borderRadius="lg" boxShadow="sm">
              <Flex wrap="wrap" gap={2}>
                {tempSkills.length > 0 ? (
                  tempSkills.map((skill, index) => (
                    <Tag key={index} size="md" variant="outline">
                      {skill}
                      <CloseIcon
                        cursor="pointer"
                        ml={2}
                        w={2}
                        h={2}
                        onClick={() => removeSkill(skill)}
                      />
                    </Tag>
                  ))
                ) : (
                  <Text fontSize="sm" color="gray.500">
                    {recruitConstant.noSkillsAdded}
                  </Text>
                )}
              </Flex>

              <HStack mt={3}>
                <Input
                  placeholder={recruitConstant.searchSkill}
                  size="sm"
                  height={"40px"}
                  value={newSkill}
                  onChange={(e) => setNewSkill(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && addSkill(newSkill)}
                />
                <Button
                  size="sm"
                  className="nextBtn theme-btn1"
                  variant="primary"
                  onClick={() => addSkill(newSkill)}
                >
                  {recruitConstant.add}
                </Button>
              </HStack>
              {filteredSkills.length > 0 && (
                <List
                  mt={2}
                  border="1px solid #ddd"
                  borderRadius="md"
                  maxH="100px"
                  overflowY="auto"
                >
                  {filteredSkills.map((skill, index) => (
                    <ListItem
                      key={index}
                      p={2}
                      cursor="pointer"
                      _hover={{ bg: "gray.100" }}
                      onClick={() => addSkill(skill)}
                    >
                      {skill}
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button variant="outline" className="theme-btn2" onClick={handleCancel}>
              {recruitConstant.cancel}
            </Button>
            <Button
              size="sm"
              className="nextBtn theme-btn1"
              variant="primary"
              ml={2}
              onClick={handleSave}
            >
              {recruitConstant.save}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isOpenSkills} onClose={onClose} size="md">
        <ModalOverlay />
        <ModalContent maxWidth={"700px"}>
          <ModalHeader>Skills</ModalHeader>
          <ModalCloseButton onClick={()=> setIsOpenSkills(false)} />

          <ModalBody className="modalBody">
            <Box p={3} borderRadius="lg" boxShadow="sm">
              <Box px={"0px"}>
                <Flex px={"0px"} wrap="wrap" gap={3} alignItems={"center"}>
                  {skills.map((skill, index) => (
                    <Tag
                      lineHeight={"12px"}
                      backgroundColor={"transparent"}
                      key={index}
                      className="modalSkillTag"
                    >
                      {skill}
                    </Tag>
                  ))}
                </Flex>
              </Box>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button size="sm" variant="outline" className="cancelBtn theme-btn2" onClick={()=> setIsOpenSkills(false)}>
              {recruitConstant.cancel}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default SkillsSection;
